import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteBeneficiaryInformation: Map<string, ConfirmationData> = new Map([
    ["c1848b54-6351-449f-92af-9455b97e1eac", { hidden: true }],
    ["a4e4edae-3451-4398-9f73-50558d3dee7b", { hiddenAll: true }],
]);



